/*
  IGO03 - BF Build Reservation
  Markup + config: snippets/igo03-build-reservation.liquid (popup, rendered once from
  layout/theme.liquid) and snippets/igo03-card.liquid (PDP card). Spec: IGO03 dev spec v1.2.

  - Card: shown while the selected variant is available and priced >= threshold.
  - One popup, three triggers: link (card "See how it works", no cap), exit (desktop exit
    intent, PDP with the card visible), cart (Rebuy drawer closes with a subtotal >= threshold).
  - exit + cart share one once-per-visitor cap (localStorage igo03_auto_done), set by any
    popup open and by the "Book My Consultation" click.
  - "Book My Consultation" opens the Calendly popup embed (UTM-tagged per trigger); new tab
    if widget.js isn't there. calendly.event_scheduled = a completed booking.
  - GA4 events via gtag (send_to G-LHVQZ62JHL), names in the spec §6.
*/
(function () {
  'use strict';

  if (window.IGO03_INIT) return;
  window.IGO03_INIT = true;

  var configEl = document.getElementById('igo03-config');
  var popup = document.querySelector('[data-igo03-popup]');
  if (!configEl || !popup) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  var CAP_KEY = 'igo03_auto_done';
  var DESKTOP_QUERY = '(min-width: 799px)';
  var FINE_POINTER_QUERY = '(hover: hover) and (pointer: fine)';
  var EXIT_MIN_PAGE_MS = 5000;
  var CART_CLOSE_DELAY_MS = 400;
  var PREFILL_MAX_CHARS = 300;
  var CALENDLY_JS = 'https://assets.calendly.com/assets/external/widget.js';
  var CALENDLY_CSS = 'https://assets.calendly.com/assets/external/widget.css';
  var UTM_CONTENT = { link: 'pdp-link', exit: 'pdp-exit', cart: 'cart-close' };

  var debug = (window.__igo03 = { version: '2026-10-18.1', events: [] });

  /* ---------- GA4 ---------- */

  var gaQueue = [];
  var gaTimer = null;

  function sendEvent(name, params) {
    window.gtag('event', name, params);
    debug.events.push(name);
  }

  function flushQueue() {
    if (typeof window.gtag !== 'function') return false;
    while (gaQueue.length) {
      var queued = gaQueue.shift();
      sendEvent(queued[0], queued[1]);
    }
    return true;
  }

  // gtag arrives with GTM/gtag.js (async): queue early events (e.g. card seen on load) for up to 20 s.
  function track(name, params) {
    var payload = { send_to: config.gaId };
    for (var key in params) payload[key] = params[key];

    if (typeof window.gtag === 'function') {
      sendEvent(name, payload);
      return;
    }
    gaQueue.push([name, payload]);
    if (gaTimer) return;
    var tries = 0;
    gaTimer = setInterval(function () {
      tries += 1;
      if (flushQueue() || tries >= 40) {
        clearInterval(gaTimer);
        gaTimer = null;
        gaQueue = [];
      }
    }, 500);
  }

  /* ---------- Auto cap (exit + cart, once per visitor) ---------- */

  var capInMemory = false;

  function capUsed() {
    if (capInMemory) return true;
    try {
      return window.localStorage.getItem(CAP_KEY) !== null;
    } catch (e) {
      return false;
    }
  }

  function setCap() {
    capInMemory = true;
    try {
      window.localStorage.setItem(CAP_KEY, '1');
    } catch (e) {}
  }

  /* ---------- PDP card ---------- */

  var card = document.querySelector('[data-igo03-card]');
  var cardVariants = {};
  var variantSelection = null;

  function currentVariantId() {
    var id = variantSelection && variantSelection.getAttribute('variant');
    return id && /^\d+$/.test(id) ? id : null;
  }

  function productParams() {
    var params = {};
    if (!card) return params;
    params.product_id = Number(card.getAttribute('data-product-id'));
    var variantId = currentVariantId();
    if (variantId) params.variant_id = Number(variantId);
    return params;
  }

  function cardVisible() {
    return !!card && card.isConnected && !card.hidden;
  }

  var seenObserver = null;
  var seenFired = false;

  function watchCardSeen() {
    if (seenFired || seenObserver || !('IntersectionObserver' in window)) return;
    seenObserver = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting && entries[i].intersectionRatio >= 0.5 && !card.hidden) {
            seenFired = true;
            seenObserver.disconnect();
            track('igo03_card_seen', productParams());
            return;
          }
        }
      },
      { threshold: [0.5] }
    );
    seenObserver.observe(card);
  }

  function updateCard() {
    var variantId = currentVariantId();
    var variant = variantId && cardVariants[variantId];
    var show = !!variant && variant.available === true && variant.price >= config.threshold;
    card.hidden = !show;
    if (show) watchCardSeen();
  }

  function initCard() {
    if (!card) return;

    var form = card.closest('[data-product-form]');
    // Rule: no Add to cart on the page = no card.
    if (!form || !form.querySelector('button[name="add"]')) {
      card.remove();
      card = null;
      return;
    }

    try {
      cardVariants = JSON.parse(card.querySelector('[data-igo03-variants]').textContent);
    } catch (e) {
      cardVariants = {};
    }

    variantSelection = form.querySelector('variant-selection');
    if (variantSelection) {
      // Flex's variant-change event doesn't bubble; the variant attribute is the source of truth.
      new MutationObserver(updateCard).observe(variantSelection, { attributes: true, attributeFilter: ['variant'] });
      updateCard();
    } else if (!card.hidden) {
      watchCardSeen();
    }
  }

  /* ---------- Popup ---------- */

  var dialog = popup.querySelector('[data-igo03-dialog]');
  var openState = null; // { trigger, opener }
  var lastCart = null;

  function focusables() {
    return Array.prototype.filter.call(dialog.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])'), function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
  }

  function onKeydown(event) {
    if (!openState) return;
    if (event.key === 'Escape' || event.key === 'Esc') {
      event.preventDefault();
      closePopup();
      return;
    }
    if (event.key !== 'Tab') return;
    var items = focusables();
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;
    if (event.shiftKey && (active === first || active === dialog || !dialog.contains(active))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (active === last || !dialog.contains(active))) {
      event.preventDefault();
      first.focus();
    }
  }

  function loadCalendly() {
    if (!document.querySelector('link[href="' + CALENDLY_CSS + '"]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = CALENDLY_CSS;
      document.head.appendChild(link);
    }
    if (!window.Calendly && !document.querySelector('script[src="' + CALENDLY_JS + '"]')) {
      var script = document.createElement('script');
      script.src = CALENDLY_JS;
      script.async = true;
      document.head.appendChild(script);
    }
  }

  function openPopup(trigger, opener) {
    if (openState) return false;
    openState = { trigger: trigger, opener: opener || null };

    popup.setAttribute('data-igo03-trigger', trigger);
    popup.hidden = false;
    // Classic (non-overlay) scrollbar: keep its gutter while scrolling is locked, so the page doesn't shift.
    if (window.innerWidth > document.documentElement.clientWidth) {
      document.documentElement.classList.add('igo03-popup-gutter');
    }
    document.documentElement.classList.add('igo03-popup-open');
    document.addEventListener('keydown', onKeydown, true);
    dialog.scrollTop = 0;
    dialog.focus();

    setCap();
    loadCalendly();
    track('igo03_popup_open_' + trigger, trigger === 'cart' ? {} : productParams());
    return true;
  }

  function closePopup() {
    if (!openState) return;
    var opener = openState.opener;
    openState = null;

    popup.hidden = true;
    document.documentElement.classList.remove('igo03-popup-open', 'igo03-popup-gutter');
    document.removeEventListener('keydown', onKeydown, true);

    if (opener && opener.isConnected && !opener.closest('[hidden]')) {
      opener.focus();
    } else if (document.activeElement && dialog.contains(document.activeElement)) {
      document.activeElement.blur();
    }
  }

  /* ---------- Calendly ---------- */

  var bookingTrigger = null;

  function calendlyUrl(trigger) {
    var base = config.calendlyUrl;
    try {
      var url = new URL(base);
      url.searchParams.set('utm_campaign', 'bf-reservation');
      url.searchParams.set('utm_content', UTM_CONTENT[trigger]);
      return url.toString();
    } catch (e) {
      return base + (base.indexOf('?') === -1 ? '?' : '&') + 'utm_campaign=bf-reservation&utm_content=' + UTM_CONTENT[trigger];
    }
  }

  function prefillNames(trigger) {
    var names = '';
    if (trigger === 'cart') {
      names = ((lastCart && lastCart.items) || [])
        .filter(function (item) {
          return item.final_line_price > 0;
        })
        .map(function (item) {
          return item.product_title;
        })
        .join(', ');
    } else if (card) {
      names = card.getAttribute('data-product-title') || '';
    }
    return names.slice(0, PREFILL_MAX_CHARS);
  }

  function onBook() {
    if (!openState) return;
    var trigger = openState.trigger;
    var url = calendlyUrl(trigger);

    setCap();
    track('igo03_book_click_' + trigger, trigger === 'cart' ? {} : productParams());
    closePopup();

    if (window.Calendly && typeof window.Calendly.initPopupWidget === 'function') {
      bookingTrigger = trigger;
      var options = { url: url };
      if (config.prefill) {
        var names = prefillNames(trigger);
        if (names) options.prefill = { customAnswers: { a1: names } };
      }
      window.Calendly.initPopupWidget(options);
    } else {
      // Same click = still a user gesture, so the tab isn't blocked. No booked event on this path.
      window.open(url, '_blank', 'noopener');
    }
  }

  window.addEventListener('message', function (event) {
    if (event.origin !== 'https://calendly.com' || !bookingTrigger) return;
    var data = event.data;
    if (!data || typeof data !== 'object' || data.event !== 'calendly.event_scheduled') return;
    var trigger = bookingTrigger;
    bookingTrigger = null;
    track('igo03_booked_' + trigger, trigger === 'cart' ? {} : productParams());
  });

  /* ---------- Auto-open guards ---------- */

  function rebuyDrawerOpen() {
    var drawer = document.getElementById('rebuy-cart');
    return !!drawer && drawer.classList.contains('is-visible');
  }

  // Something fixed (Alia popup, Blueprint popup, a modal, the Rebuy backdrop) covers the page centre.
  function pageCovered() {
    var el = document.elementFromPoint(window.innerWidth / 2, window.innerHeight / 2);
    for (; el && el !== document.documentElement; el = el.parentElement) {
      if (window.getComputedStyle(el).position === 'fixed') return true;
    }
    return false;
  }

  /* ---------- Trigger: exit intent (desktop PDP) ---------- */

  function initExitIntent() {
    if (!config.exitEnabled || !card) return;
    var desktop = window.matchMedia(DESKTOP_QUERY);
    var finePointer = window.matchMedia(FINE_POINTER_QUERY);

    document.addEventListener('mouseout', function (event) {
      if (event.relatedTarget !== null || event.clientY > 0) return;
      if (openState || !desktop.matches || !finePointer.matches) return;
      if (!cardVisible() || window.performance.now() < EXIT_MIN_PAGE_MS) return;
      if (rebuyDrawerOpen() || document.body.classList.contains('accessory-modal--open')) return;
      if (capUsed() || pageCovered()) return;
      openPopup('exit', null);
    });
  }

  /* ---------- Trigger: Rebuy cart close ---------- */

  function initCartClose() {
    if (!config.cartCloseEnabled) return;

    var leaving = false;
    var drawerNavClick = false;

    window.addEventListener('pagehide', function () {
      leaving = true;
    });
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) leaving = false;
    });

    document.addEventListener('rebuy:smartcart.show', function () {
      drawerNavClick = false;
    });

    // Checkout, wallets or any link inside the drawer = the shopper is moving on, not abandoning.
    document.addEventListener(
      'click',
      function (event) {
        var drawer = document.getElementById('rebuy-cart');
        var target = event.target;
        if (!drawer || !target || !target.closest || !drawer.contains(target)) return;
        if (target.closest('a[href], .rebuy-cart__checkout-button, shopify-accelerated-checkout, [data-shopify="payment-button"]')) {
          drawerNavClick = true;
        }
      },
      true
    );

    document.addEventListener('rebuy:smartcart.hide', function () {
      setTimeout(function () {
        if (leaving || drawerNavClick || openState || capUsed()) return;

        fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            if (leaving || openState || capUsed() || rebuyDrawerOpen()) return;
            if (cart.currency !== config.currency || !(cart.items_subtotal_price >= config.threshold)) return;
            if (pageCovered()) return;
            lastCart = cart;
            openPopup('cart', null);
          })
          .catch(function () {});
      }, CART_CLOSE_DELAY_MS);
    });
  }

  /* ---------- Wire up ---------- */

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var openLink = target.closest('[data-igo03-open]');
    if (openLink) {
      event.preventDefault();
      openPopup('link', openLink);
      return;
    }

    if (!openState || !popup.contains(target)) return;
    if (target.closest('[data-igo03-book]')) {
      onBook();
    } else if (target.closest('[data-igo03-close]')) {
      closePopup();
    }
  });

  initCard();
  initExitIntent();
  initCartClose();
})();
